"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "JsonGeneralHandler", {
    enumerable: true,
    get: function() {
        return JsonGeneralHandler;
    }
});
const _nocodbsdk = require("nocodb-sdk");
const _catchError = require("src/helpers/catchError");
const _constants = require("src/constants");
const _generic = require("~/db/field-handler/handlers/generic");
const _sqlSanitize = require("~/helpers/sqlSanitize");
const _handlerUtils = require("~/db/field-handler/utils/handlerUtils");
let JsonGeneralHandler = class JsonGeneralHandler extends _generic.GenericFieldHandler {
    async filter(knex, filter, column, options) {
        const { alias } = options;
        const field = (0, _sqlSanitize.sanitize)(alias ? `${alias}.${column.column_name}` : column.column_name);
        let val = filter.value;
        return {
            rootApply: undefined,
            clause: (qb)=>{
                const appendIsNull = ()=>{
                    qb.where((nestedQb)=>{
                        nestedQb.whereNull(field).orWhere(knex.raw("?? = '{}'", [
                            field
                        ])).orWhere(knex.raw("?? = '[]'", [
                            field
                        ]));
                    });
                };
                const appendIsNotNull = ()=>{
                    qb.whereNotNull(field).whereNot(knex.raw("?? = '{}'", [
                        field
                    ])).whereNot(knex.raw("?? = '[]'", [
                        field
                    ]));
                };
                switch(filter.comparison_op){
                    case 'eq':
                        if (!(0, _handlerUtils.ncIsStringHasValue)(val)) {
                            qb.where((nestedQb)=>{
                                nestedQb.whereNull(field);
                            });
                        } else {
                            const { jsonVal, isValidJson } = this.parseJsonValue(val);
                            if (isValidJson) {
                                qb.where(knex.raw('?? = ?', [
                                    field,
                                    jsonVal
                                ]));
                            } else {
                                qb.where(knex.raw('?? = ?', [
                                    field,
                                    jsonVal
                                ]));
                            }
                        }
                        break;
                    case 'neq':
                    case 'not':
                        if (!(0, _handlerUtils.ncIsStringHasValue)(val)) {
                            qb.where((nestedQb)=>{
                                nestedQb.whereNotNull(field);
                            });
                        } else {
                            const { jsonVal, isValidJson } = this.parseJsonValue(val);
                            qb.where((nestedQb)=>{
                                if (isValidJson) {
                                    nestedQb.where(knex.raw('?? != ?', [
                                        field,
                                        jsonVal
                                    ]));
                                } else {
                                    nestedQb.where(knex.raw('?? != ?', [
                                        field,
                                        jsonVal
                                    ]));
                                }
                                nestedQb.orWhereNull(field);
                            });
                        }
                        break;
                    case 'like':
                        val = val ? `%${val}%` : val;
                        if (!val) {
                            qb.whereNotNull(field);
                        } else {
                            qb.where(knex.raw('?? like ?', [
                                field,
                                val
                            ]));
                        }
                        break;
                    case 'nlike':
                        if (!(0, _handlerUtils.ncIsStringHasValue)(val)) {
                            qb.whereNotNull(field);
                        } else {
                            val = `%${val}%`;
                            qb.where((nestedQb)=>{
                                nestedQb.where(knex.raw('?? not like ?', [
                                    field,
                                    val
                                ]));
                                if (val !== '%%') {
                                    nestedQb.orWhere(field, '').orWhereNull(field);
                                } else {
                                    nestedQb.orWhereNull(field);
                                }
                            });
                        }
                        break;
                    case 'blank':
                        appendIsNull();
                        break;
                    case 'notblank':
                        appendIsNotNull();
                        break;
                    case 'is':
                        switch(val){
                            case 'null':
                            case 'blank':
                            case 'empty':
                                {
                                    appendIsNull();
                                    break;
                                }
                            case 'notnull':
                            case 'notblank':
                            case 'notempty':
                                {
                                    appendIsNotNull();
                                    break;
                                }
                        }
                        break;
                    case 'isnot':
                        switch(val){
                            case 'null':
                            case 'blank':
                            case 'empty':
                                {
                                    appendIsNotNull();
                                    break;
                                }
                            case 'notnull':
                            case 'notblank':
                            case 'notempty':
                                {
                                    appendIsNull();
                                    break;
                                }
                        }
                        break;
                    default:
                        _catchError.NcError._.unsupportedFilterOperation(filter.comparison_op);
                }
            }
        };
    }
    parseJsonValue(val) {
        let jsonVal = val;
        let isValidJson = false;
        if (typeof val === 'object' && val !== null) {
            jsonVal = JSON.stringify(val);
            isValidJson = true;
        } else if (typeof val === 'string') {
            try {
                JSON.parse(val);
                jsonVal = val;
                isValidJson = true;
            } catch (unused) {
                jsonVal = val;
            }
        }
        return {
            jsonVal,
            isValidJson
        };
    }
    async verifyFilter(filter, column) {
        return super.verifyFilter(filter, column);
    }
    async parseUserInput(params) {
        var _ref;
        if ((0, _nocodbsdk.ncIsUndefined)(params.value) || (0, _nocodbsdk.ncIsNull)(params.value)) {
            return {
                value: params.value
            };
        }
        const length = (_ref = typeof params.value === 'string' && params.value.length) != null ? _ref : typeof params.value === 'object' && JSON.stringify(params.value).length;
        if (length > _constants.NC_MAX_TEXT_LENGTH) {
            _catchError.NcError._.valueLengthExceedLimit({
                column: params.column.title,
                type: params.column.uidt,
                length,
                maxLength: _constants.NC_MAX_TEXT_LENGTH
            });
        }
        const parseJsonResult = this.parseJsonValue(params.value);
        if (parseJsonResult.isValidJson) {
            return {
                value: parseJsonResult.jsonVal
            };
        } else {
            _catchError.NcError.invalidValueForField({
                value: params.value,
                column: params.column.title,
                type: params.column.uidt
            });
        }
    }
};
